import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl, HelpBlock, Glyphicon, Button } from 'react-bootstrap';
import FirebaseService from '../service/FirebaseService';

// 百事利器材有限公司

// 葵芳葵豐街一至十五號盈業工廠大厦8樓11室

// 電話： (852) 24236378
// 傳真： (852) 24872790
// 電郵 sales@preseli.com.hk

//========================================================

// 名稱 :	

// 姓氏 :	

// 標題 :	Mr Mrs Miss
// 電郵地址 :	

// 聯絡電話 :	
// 產品 :	化氣爐  氣體控制設備  調壓器 
// 流量計  熱水爐  壓縮機 
// 液位計  閥門  高壓軟管 
// 自動交換器  防爆形氣體感應器  水泵 
// 磁力化學泵  球閥  其他配件 
// 穩壓器
// 內容 :	

//  	送出

export default class Contact extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            value: {
                name: "",
                company: "",
                email: "",
                contactMessage: ""
            }
        }

        this.handleFieldValueChange = this.handleFieldValueChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.sendFormData = this.sendFormData.bind(this);
    }

    getValidationState() {
        // console.log("getValidationState");

        const length = this.state.value.length;
        if (length > 10) return 'success';
        else if (length > 5) return 'warning';
        else if (length > 0) return 'error';
    }

    handleFieldValueChange(e) {
        this.setState({ value: e.target.value });
        // console.log(this.state);
    }

    handleSubmit(e) {
        e.preventDefault();
        // document.getElementById('title-divider').scrollIntoView();
        // console.log("handleSubmit")

        var formData = {
            name: ReactDOM.findDOMNode(this.refs.name).value,
            email: ReactDOM.findDOMNode(this.refs.email).value,
            company: ReactDOM.findDOMNode(this.refs.company).value,
            contactMessage: ReactDOM.findDOMNode(this.refs.contactMessage).value
        };

        this.setState({ type: 'info', message: 'Sending...' });
        this.sendFormData(formData, message => {
            this.setState(message);
        });
    }

    sendFormData(formData, callback) {
        // Fetch form values.
        //https://www.lullabot.com/articles/processing-forms-in-react
        //https://github.com/Lullabot/react_form/blob/master/src/contact-form.jsx

        FirebaseService.saveContactForm(formData, function (message) {
            // console.log(message);
            callback(message)
        });
        // Subscribe to the newsletter.
        //https://github.com/firebase/functions-samples/blob/master/email-confirmation/public/main.js
        // Demo.prototype.subscribe = function () {
        //     return firebase.database().ref('users/' + firebase.auth().currentUser.uid).set({
        //         subscribedToMailingList: true,
        //         email: firebase.auth().currentUser.email
        //     });
        // };
    }

    render() {

        var submitted

        if (this.state.type && this.state.message) {
            var classString = 'alert alert-' + this.state.type + ' my-4';
            var sendStatus = <div id="status" className={classString} ref="status">
                {this.state.message}
            </div>;
        }

        if (this.state.submitted === true) {
            submitted = <div className="alert alert-success my-4">
                <p>ContactForm data:</p>
                <pre><code>{JSON.stringify(this.state.value, null, '  ')}</code></pre>
            </div>
            form = submitted;
            // console.log("submitted")
        }

        var form = <div className="row">
            <div className="col-md-6">
                <form id="contact-form" action="" role="form" onSubmit={this.handleSubmit}>
                    <FormGroup controlId="name" validationState={this.getValidationState()}>
                        <FormControl type="text" placeholder={this.props.getTranslatedText("Name")} onChange={this.handleFieldValueChange} ref="name" />
                        <FormControl.Feedback />
                        {/* <HelpBlock>Please enter your name</HelpBlock> */}
                    </FormGroup>
                    <FormGroup controlId="company" validationState={this.getValidationState()}>
                        <FormControl type="text" placeholder={this.props.getTranslatedText("Company")} onChange={this.handleFieldValueChange} ref="company" />
                        <FormControl.Feedback />
                        {/* <HelpBlock>Please enter your company's name</HelpBlock> */}
                    </FormGroup>
                    <FormGroup controlId="email" validationState={this.getValidationState()}>
                        <FormControl type="email" placeholder={this.props.getTranslatedText("Email")} onChange={this.handleFieldValueChange} ref="email" />
                        <FormControl.Feedback />
                        {/* <HelpBlock>Please enter a email</HelpBlock> */}
                    </FormGroup>
                    <FormGroup controlId="contactMessage" validationState={this.getValidationState()}>
                        <FormControl componentClass="textarea" placeholder={this.props.getTranslatedText("TellUs")} onChange={this.handleFieldValueChange} ref="contactMessage" />
                        <FormControl.Feedback />
                        {/* <HelpBlock>Please enter your message</HelpBlock> */}
                    </FormGroup>

                    {/*<div className="form-group">
                                        <label className="sr-only" for="contact-name">Company</label>
                                        <input type="text" className="form-control" id="company" placeholder="Name" />
                                        <small id="contact-name-help" className="form-text text-muted">First and last names.</small>
                                    </div>
                                    <div className="form-group">
                                        <label className="sr-only" for="contact-name">Phone</label>
                                        <input type="text" className="form-control" id="phone" placeholder="Name" />
                                        <small id="contact-name-help" className="form-text text-muted">First and last names.</small>
                                    </div>
                                    <div className="form-group">
                                        <label className="sr-only" for="contact-email">Email</label>
                                        <input type="email" className="form-control" id="email" placeholder="Email" />
                                        <small id="contact-email-help" className="form-text text-muted">We'll never share your email with anyone else.</small>
                                    </div>
                                    <div className="form-group">
                                        <label className="sr-only" for="contact-message">Message</label>
                                        <textarea rows="12" className="form-control" id="message" placeholder="Message"></textarea>
                                        <small id="contact-message-help" className="form-text text-muted">Your message and details.</small>
                                    </div>*/}
                    <input type="submit" className="btn btn-primary" value={this.props.getTranslatedText("SendMessage")}/>
                    {sendStatus}
                </form>
            </div>
            <div className="col-md-6">
                <p><abbr title="Phone"><i className="fa fa-phone"></i></abbr>(+852) 24236378</p>
                <p><abbr title="Email"><i className="fa fa-envelope"></i></abbr>sales@preseli.com.hk</p>
                <p><abbr title="Address"><i className="fa fa-home"></i></abbr>{this.props.getTranslatedText("AddressLine1")}{this.props.getTranslatedText("AddressLine2")}</p>
                <p>
                    <iframe className="maps" frameBorder="0" scrolling="0" src="https://maps.google.com/maps?hl=en&amp;ie=UTF8&amp;t=m&amp;z=15&amp;iwloc=B&amp;iwd=1&amp;output=embed&amp;q=Flat+11%2C+8%2FF.%2C+Profit+Ind.+Bldg.%2C+1-15+Kwai+Fung+Crescent%2C+Kwai+Fong%2C+N.T.+Hong+Kong."></iframe>
                    {/*<a href="https://maps.google.co.uk/maps?q=London&amp;ie=UTF8&amp;hq=&amp;hnear=London,+United+Kingdom&amp;gl=uk&amp;t=m&amp;ll=51.510238,-0.127029&amp;spn=0.042735,0.102654&amp;z=12&amp;">
                        <img src="assets/img/misc/map.png" alt="Location map" className="img-thumbnail" />
                    </a>*/}
                </p>
            </div>
        </div>


        return (
            <Grid className="py-4">
                <Row>
                    <div className="col-md-12">
                        <h2 className="title-divider">
                            <span>{this.props.getTranslatedText("Contact")}<span className="font-weight-normal text-muted">{this.props.getTranslatedText("Us")}</span></span>
                            <small>{this.props.getTranslatedText("WaysToGetInTouch")}</small>
                        </h2>
                        {form}
                    </div>
                </Row>
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Contact.js